import { render } from "./Gamification.vue?vue&type=template&id=3ae2cf03&scoped=true"
import script from "./Gamification.vue?vue&type=script&lang=js"
export * from "./Gamification.vue?vue&type=script&lang=js"

import "./Gamification.vue?vue&type=style&index=0&id=3ae2cf03&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae2cf03"]])

export default __exports__